import Base from '../../Base';
import styles from './Points.module.scss';

const Points = () => {

  return (
    <Base title='Points'>
      <div className={styles.root}>
        <p>
          Complete your campaign activities to receive Chimeable Points
          upon approval. You can use these points to participate in a future
          campaign of your choice.
        </p>
      </div>
    </Base>
  );
};

export default Points;